// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorPreview_aZy2t {
  width:100%;
  flex : 1 0 300px;
}
.editor_Nx1wA {
  height : 100%;
  border : 1px solid var( --lighter-grey );
  position: relative;
  display : flex;
  flex-direction: row;
  flex : 1 1 auto;
}

.wrap_FeWgZ {
  flex:1 1  auto;
  flex-direction: column;
  display:flex;
  border:1px solid #efefef;
  height:100%;
  overflow:hidden;
  position : relative;
}

.header_Z9603 {
  font-size: 16px;
  /*font-family: Montserrat, san-serif;*/
  color: #5737BE;
}

.limitOptions_G3dAt {
  flex: 1 0 auto;
  align-self : flex-start;
}
.iframe_yCDke {
  flex : 1 1 300px;
  border:0;
}
.editorFlex_c3MDy {
  height : 100%;
  padding : 0 24px !important;
  margin-right: auto;
  margin-left: auto;
  .headerRow_erzaO {
    flex: 0 0 auto;
  }
}
.row_BdV6w {
  width: 100%;
  display: flex;
}
.deployCode_NQPkk {
  margin-left: 8px;
}
.deployCode_NQPkk .text_o9JzM {
  margin-right: 5px;
}

.deployCode_NQPkk > * {
  color: var( --purple );
}

.themeDropdown_Tgodx {
  width: 150px;
  margin-right: 15px;
}

.pad_wKDaI {
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/editors/template/style.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import \"../../style/theme.css\";\n\n.editorPreview {\n  width:100%;\n  flex : 1 0 300px;\n}\n.editor {\n  height : 100%;\n  border : 1px solid var( --lighter-grey );\n  position: relative;\n  display : flex;\n  flex-direction: row;\n  flex : 1 1 auto;\n}\n\n.wrap {\n  flex:1 1  auto;\n  flex-direction: column;\n  display:flex;\n  border:1px solid #efefef;\n  height:100%;\n  overflow:hidden;\n  position : relative;\n}\n\n.header {\n  font-size: 16px;\n  /*font-family: Montserrat, san-serif;*/\n  color: #5737BE;\n}\n\n.limitOptions {\n  flex: 1 0 auto;\n  align-self : flex-start;\n}\n.iframe {\n  flex : 1 1 300px;\n  border:0;\n}\n.editorFlex {\n  height : 100%;\n  padding : 0 24px !important;\n  margin-right: auto;\n  margin-left: auto;\n  .headerRow {\n    flex: 0 0 auto;\n  }\n}\n.row {\n  width: 100%;\n  display: flex;\n}\n.deployCode {\n  margin-left: 8px;\n}\n.deployCode .text {\n  margin-right: 5px;\n}\n\n.deployCode > * {\n  color: var( --purple );\n}\n\n.themeDropdown {\n  width: 150px;\n  margin-right: 15px;\n}\n\n.pad {\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorPreview": `editorPreview_aZy2t`,
	"editor": `editor_Nx1wA`,
	"wrap": `wrap_FeWgZ`,
	"header": `header_Z9603`,
	"limitOptions": `limitOptions_G3dAt`,
	"iframe": `iframe_yCDke`,
	"editorFlex": `editorFlex_c3MDy`,
	"headerRow": `headerRow_erzaO`,
	"row": `row_BdV6w`,
	"deployCode": `deployCode_NQPkk`,
	"text": `text_o9JzM`,
	"themeDropdown": `themeDropdown_Tgodx`,
	"pad": `pad_wKDaI`
};
export default ___CSS_LOADER_EXPORT___;
